// Props do react-select no visual do Jusfy DS (campo 40px, radius small,
// borda neutral-strong, foco brand, opção/chip brand-subtler). Todo slot usa
// token, então o dark vira de graça; sem estilo, o react-select ficaria branco.
const token = (name) => `var(--${name})`;

export const jdsSelectProps = {
  // classes jds-select__* para o _dark.scss (setas, avisos do menu, menu dentro de modal)
  classNamePrefix: 'jds-select',
  theme: (theme) => ({
    ...theme,
    borderRadius: 5,
    colors: {
      ...theme.colors,
      primary: token('bg-brand-default'), // opção selecionada (texto branco em cima)
      primary25: token('bg-brand-subtler'),
      primary50: token('bg-brand-subtler'),
    },
  }),
  styles: {
    control: (base, { isFocused, isDisabled }) => ({
      ...base,
      minHeight: 40,
      backgroundColor: isDisabled
        ? token('state-disabled-outlined-bg')
        : token('bg-neutral-layer01'),
      borderColor: isFocused
        ? token('border-brand-default')
        : token('border-neutral-strong'),
      boxShadow: 'none',
      '&:hover': { borderColor: token('border-brand-default') },
    }),
    // bg-floating: layer01 no light (branco), layer02 no dark (menu elevado)
    menu: (base) => ({
      ...base,
      backgroundColor: token('bg-floating'),
      boxShadow: token('shadow-md'),
    }),
    // opção desabilitada: a lib usa #ccc; o token (cinza-500 no light) é praticamente igual e flipa no dark
    option: (base, { isDisabled }) => ({
      ...base,
      color: isDisabled ? token('state-disabled-outlined-fg') : base.color,
    }),
    placeholder: (base) => ({ ...base, color: token('fg-neutral-subtle') }),
    singleValue: (base, { isDisabled }) => ({
      ...base,
      color: isDisabled
        ? token('state-disabled-outlined-fg')
        : token('fg-neutral-default'),
    }),
    input: (base) => ({ ...base, color: token('fg-neutral-default') }),
    indicatorSeparator: (base) => ({
      ...base,
      backgroundColor: token('border-neutral-default'),
    }),
    multiValue: (base) => ({
      ...base,
      background: token('bg-brand-subtler'),
      borderRadius: 999,
      paddingLeft: 4,
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: token('fg-brand-stronger'),
      borderRadius: '999px 0 0 999px',
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: token('fg-brand-stronger'),
      borderRadius: '0 999px 999px 0',
      paddingRight: 6,
      '&:hover': {
        backgroundColor: token('bg-error-subtler'),
        color: token('fg-error-strong'),
      },
    }),
  },
};
